import React, { useEffect, useState } from "react";

import "./Laboratory.css";

import BtnAdd from "../Commons/Buttons/BtnAdd";
import AntDTable from "../AntDTable/AntDTable";
import SelectField from "../Commons/Forms/SelectField";
import DeleteModal from "../Modals/DeleteModal";

// import { Row, Col } from "react-bootstrap";
import { Card, Button as AntButton, Input } from "antd";
import { useParams } from "react-router-dom";
import {
  deleteLabResult,
  getLabTests,
  getAllLabResults,
  getLabTestResult,
} from "../Helpers/API/LabApi/LaboratoryApi";
import {
  capitalizeFirstLetter,
  formatDate,
  formatLabel,
  getPatientBranchId,
  setPatientBranchId,
} from "../Helpers/Utilities/Common";
import { getLaboratoryResult } from "../Helpers/API/LabApi/LaboratoryResultApi";
import { toast } from "react-toastify";
import { SeeAttachment } from "../Radiology/SeeAttachment";
import { RefreshRounded } from "@mui/icons-material";
import { Col, Row, Modal } from "react-bootstrap";
import BtnSave from "../Commons/Buttons/BtnSave";

function LaboratoryResults(props) {
  const { id } = useParams();
  const [searchLabTest, setSearchLabTest] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [laboratories, setLaboratories] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [transactionTests, setTransactionTests] = useState([]);
  const [transactionTestsLoading, setTransactionTestsLoading] = useState(false);
  const [autoOpened, setAutoOpened] = useState(false);

  // Function to delete lab result API
  const handleDelete = async () => {
    const res = await deleteLabResult(selectedRow.id);
    if (res.data) {
      toast.success(res.data.message);
      setSelectedRow({});
      setShowDelete(false);
      fetchData();
    } else if (res.error) {
      res.error.data.messages.error_messages.forEach((err) => {
        toast.error(err);
      });
    }
  };

  // Function show lab form
  function handleShowLabForm() {
    props.setShowCheckupTabs(false);
    props.showLabForm(true);
    props.showEvalForm(false);
  }

  // Function show evaluation form
  function handleShowEvalForm(data) {
    props.setAddEvaluation(data);
    props.setShowCheckupTabs(false);
    props.showLabForm(false);
    props.showEvalForm(true);
  }

  const normalizeStatus = (status) =>
    (status || "").toString().trim().toLowerCase();

  const isCompletedForEvaluation = (status) => {
    const value = normalizeStatus(status);

    // Treat these statuses as ready for evaluation
    return (
      value === "finalized" ||
      value === "waive" ||
      value === "waived" ||
      value === "for_evaluation" ||
      value === "for evaluation"
    );
  };

  const getTransactionStatus = (tests = []) => {
    if (!tests.length) {
      return "";
    }

    const normalizedStatuses = tests.map((test) =>
      normalizeStatus(test?.status)
    );

    const allEvaluated = normalizedStatuses.every(
      (status) => status === "evaluated"
    );

    if (allEvaluated) {
      return "Evaluated";
    }

    const readyForEvaluationStatuses = [
      "finalized",
      "waive",
      "waived",
      "for_evaluation",
      "for evaluation",
    ];

    const allCompletedForEval = normalizedStatuses.every((status) =>
      readyForEvaluationStatuses.includes(status)
    );

    if (allCompletedForEval) {
      return "For Evaluation";
    }

    return "Pending";
  };

  const openEvaluationForTransaction = async (transaction, fallbackCandidate) => {
    if (!transaction) {
      return;
    }

    const baseTests = transaction.tests || [];

    const transactionId =
      transaction.transaction_id ||
      transaction.transactionKey ||
      transaction.transactionNo;

    let detailedTests = baseTests;

    if (transactionId) {
      try {
        const res = await getLabTestResult({
          transaction_id: transactionId,
          patient_id: props.patientId || id,
          branch_id: transaction.branch_id || getPatientBranchId() || "",
          table_name: "booking",
        });

        if (res?.data?.data) {
          detailedTests = res.data.data.map((lab) => {
            const normalizedAttachments = Array.isArray(lab.lab_result_attachments)
              ? lab.lab_result_attachments
              : lab.file_url
              ? [
                  {
                    file_url: lab.file_url,
                    file_name: lab.file_name || "Attachment",
                  },
                ]
              : [];

            return {
              ...lab,
              lab_result_attachments: normalizedAttachments,
              formatted_lab_name:
                lab.lab_name !== "laboratory" && lab.lab_name !== "others"
                  ? formatLabel(lab.lab_test_sub_type).toUpperCase()
                  : formatLabel(lab.lab_name).toUpperCase(),
              formattedStatus: (lab.status || "").toString().toUpperCase(),
              formattedResultDate: formatDate(lab.result_date),
            };
          });
        }
      } catch (error) {
        detailedTests = baseTests;
      }
    }

    const evaluationCandidate =
      detailedTests.find((test) => isCompletedForEvaluation(test?.status)) ||
      fallbackCandidate;

    if (!evaluationCandidate) {
      return;
    }

    // Save branch_id from transaction for evaluation
    if (transaction.branch_id) {
      setPatientBranchId(transaction.branch_id);
    }

    handleShowEvalForm({
      ...evaluationCandidate,
      source_id: transaction.transaction_id || transactionId,
      table_name: "booking",
      is_force_evaluation: false,
      _transaction: transaction,
      _transaction_id: transactionId,
      _transaction_no:
        transaction?.transactionNo || transaction?.transactionKey || transactionId,
      _transaction_tests: detailedTests,
    });
  };

  const openForceEvaluationForTransaction = async (transaction) => {
    if (!transaction) {
      return;
    }
    const baseTests = transaction.tests || [];
    const transactionId =
      transaction.transaction_id ||
      transaction.transactionKey ||
      transaction.transactionNo;
    let detailedTests = baseTests;
    if (transactionId) {
      try {
        const res = await getLabTestResult({
          transaction_id: transactionId,
          patient_id: props.patientId || id,
          branch_id: transaction.branch_id || getPatientBranchId() || "",
          table_name: "booking",
        });
        if (res?.data?.data) {
          detailedTests = res.data.data.map((lab) => {
            const normalizedAttachments = Array.isArray(lab.lab_result_attachments)
              ? lab.lab_result_attachments
              : lab.file_url
              ? [
                  {
                    file_url: lab.file_url,
                    file_name: lab.file_name || "Attachment",
                  },
                ]
              : [];

            return {
              ...lab,
              lab_result_attachments: normalizedAttachments,
              formatted_lab_name:
                lab.lab_name !== "laboratory" && lab.lab_name !== "others"
                  ? formatLabel(lab.lab_test_sub_type).toUpperCase()
                  : formatLabel(lab.lab_name).toUpperCase(),
              formattedStatus: (lab.status || "").toString().toUpperCase(),
              formattedResultDate: formatDate(lab.result_date),
            };
          });
        }
      } catch (error) {
        detailedTests = baseTests;
      }
    }
    const fallbackCandidate = baseTests[0] || (detailedTests && detailedTests[0]) || null;
    if (!fallbackCandidate) {
      return;
    }
    
    // Save branch_id from transaction for evaluation
    if (transaction.branch_id) {
      setPatientBranchId(transaction.branch_id);
    }
    
    handleShowEvalForm({
      ...fallbackCandidate,
      source_id: transaction.transaction_id || transactionId,
      table_name: "booking",
      is_force_evaluation: true,
      _transaction: transaction,
      _transaction_id: transactionId,
      _transaction_no:
        transaction?.transactionNo || transaction?.transactionKey || transactionId,
      _transaction_tests: detailedTests,
    });
  };

  function ActionBtn(row) {
    const transaction = row?.row;
    const tests = transaction?.tests || [];
    const transactionStatus = transaction?.status || getTransactionStatus(tests);
    const isForEvaluation = transactionStatus === "For Evaluation";
    const isPending = transactionStatus === "Pending";

    const evaluationCandidate = tests.find((test) =>
      isCompletedForEvaluation(test?.status)
    );

    return (
      <div className="d-flex flex-column">
        <div className="mb-1">
          <BtnSave
            id={"green-btn"}
            label={"Evaluate"}
            size={"sm"}
            disabled={!(isForEvaluation || isPending)}
            onClick={(e) => {
              e.stopPropagation();
              if (isForEvaluation && evaluationCandidate) {
                openEvaluationForTransaction(transaction, evaluationCandidate);
              } else if (isPending) {
                openForceEvaluationForTransaction(transaction);
              }
            }}
          />
        </div>
      </div>
    );
  }

  // Function get Laboratory Results
  async function fetchData() {
    setShowLoader(true);
    const response = await getAllLabResults({
      patient_id: props.patientId || id,
      branch_id: getPatientBranchId() || "",
    });

    if (response?.data?.data) {
      let records = response.data.data;
      
      // Save branch_id from the first record to localStorage for evaluation
      if (records.length > 0 && records[0].branch_id) {
        setPatientBranchId(records[0].branch_id);
      }

      // Apply client-side search filter (still based on individual tests)
      if (searchLabTest) {
        const query = searchLabTest.toLowerCase();
        records = records.filter((lab) => {
          const fieldsToSearch = [
            lab.lab_name,
            lab.lab_test_name,
            lab.result,
            lab.status,
          ];

          return fieldsToSearch.some((val) =>
            (val || "").toString().toLowerCase().includes(query)
          );
        });
      }

      // Normalize each test record
      const parsedTests = records.map((lab) => {
        const normalizedAttachments = Array.isArray(lab.lab_result_attachments)
          ? lab.lab_result_attachments
          : lab.file_url
          ? [
              {
                file_url: lab.file_url,
                file_name: lab.file_name || "Attachment",
              },
            ]
          : [];

        return {
          ...lab,
          lab_result_attachments: normalizedAttachments,
          formatted_lab_name:
            lab.lab_name !== "laboratory" && lab.lab_name !== "others"
              ? formatLabel(lab.lab_test_sub_type).toUpperCase()
              : formatLabel(lab.lab_name).toUpperCase(),
          formattedStatus: (lab.status || "").toString().toUpperCase(),
          attachment: <SeeAttachment attachments={normalizedAttachments} />,
          formattedResultDate: formatDate(lab.result_date),
        };
      });

      // Group tests per transaction
      const transactionsMap = parsedTests.reduce((acc, test) => {
        const transactionKey =
          test.transaction_no ||
          test.transaction_id ||
          test.source_id ||
          test.assessment_id ||
          test.id;

        const transactionNo = test.transaction_no || transactionKey;
        const transactionDateRaw = test.transaction_date || test.result_date;
        const transactionDateFormatted = transactionDateRaw
          ? formatDate(transactionDateRaw)
          : test.formattedResultDate;

        if (!acc[transactionKey]) {
          acc[transactionKey] = {
            key: transactionKey,
            transactionKey,
            transactionNo,
            formattedTransactionDate: transactionDateFormatted,
            transaction_id:
              test.transaction_id ||
              test.source_id ||
              test.assessment_id ||
              test.id,
            branch_id: test.branch_id,
            tests: [],
          };
        }

        acc[transactionKey].tests.push(test);

        return acc;
      }, {});

      const transactions = Object.values(transactionsMap).map((transaction) => ({
        ...transaction,
        status: getTransactionStatus(transaction.tests),
      }));

      setTableData(transactions);
    } else {
      setTableData([]);
    }

    setShowLoader(false);
  }

  function handleLabTestChange(e) {
    setSearchLabTest(e);
  }

  const handleEmptySearch = (e) => {
    if (e.target.value === "") {
      setSearchLabTest("");
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchLabTest]);

  useEffect(() => {
    if (props.autoOpenEvaluation && !autoOpened && tableData && tableData.length) {
      const transaction = tableData[0];
      const status = transaction?.status || "";
      const tests = transaction?.tests || [];
      const evaluationCandidate = tests.find((t) => isCompletedForEvaluation(t?.status));
      if (status === "For Evaluation" && evaluationCandidate) {
        openEvaluationForTransaction(transaction, evaluationCandidate);
        setAutoOpened(true);
      } else if (status === "Pending") {
        openForceEvaluationForTransaction(transaction);
        setAutoOpened(true);
      } else if (evaluationCandidate) {
        openEvaluationForTransaction(transaction, evaluationCandidate);
        setAutoOpened(true);
      }
    }
  }, [props.autoOpenEvaluation, tableData, autoOpened]);

  const handleTransactionRowClick = async (record) => {
    setSelectedTransaction(record);
    setShowTransactionModal(true);
    setTransactionTests([]);

    const transactionId =
      record.transaction_id || record.transactionKey || record.transactionNo;

    if (!transactionId) {
      setTransactionTests(record.tests || []);
      return;
    }

    setTransactionTestsLoading(true);
    try {
      const res = await getLabTestResult({
        transaction_id: transactionId,
        patient_id: props.patientId || id,
        branch_id: record.branch_id || getPatientBranchId() || "",
        table_name: 'booking',
      });

      if (res?.data?.data) {
        const tests = res.data.data.map((lab) => {
          const normalizedAttachments = Array.isArray(lab.lab_result_attachments)
            ? lab.lab_result_attachments
            : lab.file_url
            ? [
                {
                  file_url: lab.file_url,
                  file_name: lab.file_name || "Attachment",
                },
              ]
            : [];

          return {
            ...lab,
            lab_result_attachments: normalizedAttachments,
            formatted_lab_name:
              lab.lab_name !== "laboratory" && lab.lab_name !== "others"
                ? formatLabel(lab.lab_test_sub_type).toUpperCase()
                : formatLabel(lab.lab_name).toUpperCase(),
            formattedStatus: (lab.status || "").toString().toUpperCase(),
            attachment: <SeeAttachment attachments={normalizedAttachments} />,
            formattedResultDate: formatDate(lab.result_date),
          };
        });

        setTransactionTests(tests);
      } else {
        setTransactionTests(record.tests || []);
      }
    } catch (error) {
      setTransactionTests(record.tests || []);
    }

    setTransactionTestsLoading(false);
  };

  return (
    <div>
      <Card className="card-with-table" style={{ minHeight: "500px" }}>
        <div>
          <div className="col pt-1 mb-4">
            <div className="row">
              <div className="col" style={{ display: "flex" }}>
                <h5 className="font-bold">LABORATORY RESULT</h5>
                <AntButton
                  type="text"
                  className="px-2"
                  onClick={fetchData}
                  icon={<RefreshRounded />}
                />
              </div>
              <div className="col-3">
                <BtnAdd
                  label={"+ Add Record"}
                  size={"md"}
                  onClick={(e) => handleShowLabForm()}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-4 pt-1 mb-2 d-flex justify-content-start">
              <Input.Search
                placeholder="Search Lab/Test"
                allowClear
                size="medium"
                onSearch={(e) => handleLabTestChange(e)}
                onChange={(e) => handleEmptySearch(e)}
              />
            </div>
          </div>
          <div className="lab-result-table">
            <AntDTable
              tableHeaders={["Transaction No.", "Transaction Date", "Status"]}
              headerSelector={["transactionNo", "formattedTransactionDate", "status"]}
              tableData={tableData}
              loading={showLoader}
              scroll={{ x: true }}
              isClickable={true}
              onRowClick={handleTransactionRowClick}
              ActionBtn={(row) => ActionBtn(row)}
              actionBtnClassName="therapeautics-prescription-button"
              withAction={false}
              searchExcluded={["transactionNo", "formattedTransactionDate"]}
            />
          </div>
        </div>
      </Card>
      <Modal
        show={showTransactionModal}
        onHide={() => setShowTransactionModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Transaction Details
            {selectedTransaction?.transactionNo && (
              <span className="ms-2">
                ({selectedTransaction.transactionNo})
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTransaction && (
            <div className="lab-result-table">
              <AntDTable
                tableHeaders={[
                  "Date",
                  "Lab",
                  "Test",
                  "Result",
                  "Status",
                  "Attachment",
                ]}
                headerSelector={[
                  "formattedResultDate",
                  "lab_name",
                  "lab_test_name",
                  "findings",
                  "formattedStatus",
                  "attachment",
                ]}
                tableData={transactionTests.length ? transactionTests : selectedTransaction.tests || []}
                loading={transactionTestsLoading}
                scroll={{ x: true }}
                isClickable={false}
                withAction={false}
                searchExcluded={["formattedResultDate", "attachment"]}
              />
            </div>
          )}
        </Modal.Body>
      </Modal>
      {/* DELETE */}
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
        title={`Are you sure you want to delete this result?`}
      />
    </div>
  );
}

export default LaboratoryResults;
